<template>
    <div>
        <v-dialog v-model="dialog_add_product" no-click-animation persistent scrollable max-width="400" lazy transition="dialog-bottom-transition">

            <v-card>

                <v-toolbar flat :height="56">
                    <v-btn icon @click="closeDialogWeb"><v-icon>close</v-icon></v-btn>
                    <v-toolbar-title>Add Item</v-toolbar-title>
                </v-toolbar>
                <v-divider></v-divider>
                  <v-card-text full-height nopadding pt-4>
                    <ValidationObserver ref="observer">
                      <v-form data-vv-scope="fields" full-width>
                          <v-layout wrap ma-0 pt-4 white-back>


                            <!-- <ValidationProvider name="Item" rules="required" v-slot="{ errors }"> -->
                                <v-flex xs12 sm12 md12 form-item>
                                    <v-autocomplete
                                        :items="$parent.filteredProducts"
                                        v-model="$parent.Form.selectedProduct"
                                        @input="$parent.fn_getProductData($parent.Form.selectedProduct.itemId)"
                                        label="Select Product"
                                        placeholder=" "
                                        item-text="itemName"
                                        item-value="itemId"
                                        return-object
                                        append>

                                        <v-list-item slot="prepend-item" class="primary--text" @click="$parent.fn_menuItemClick('newproduct')">
                                            <v-list-item-title>Create New</v-list-item-title>
                                        </v-list-item>
                                    </v-autocomplete>    
                                </v-flex>
                                    
                                    
                                <!-- </ValidationProvider> -->


                            <template v-if="$parent.Form.productData">
                                <v-flex xs6 sm6 md6 form-item>
                                    <ValidationProvider name="Item" rules="required|decimal3" v-slot="{ errors }">
                                        <v-text-field 
                                            :disabled="$parent.Form.productData && $parent.Form.productData.batches && $parent.Form.productData.batches.length ? true : false"
                                            v-model="$parent.Form.qty"
                                            label="Qty" 
                                            placeholder=" "
                                            type="number"
                                            :error-messages="errors">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-flex>

                                <v-flex xs6 sm6 md6 form-item>
                                    <ValidationProvider name="Rate" rules="decimal2" v-slot="{ errors }">
                                        <v-text-field 
                                            v-model="$parent.Form.averageRate"
                                            label="Rate" 
                                            placeholder=" "
                                            type="number"
                                            :error-messages="errors">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-flex>
                            </template>

                            <template v-if="$parent.Form.productData && $parent.Form.averageRate">
								<v-flex pr-4 xs12 sm12 md12 right-align>Rate: {{ $root.numberToLocale($parent.Form.averageRate) }}</v-flex>
								<v-flex pr-4 xs12 sm12 md12 right-align>Amount: &#8377; {{ $root.numberToLocale($parent.Form.averageRate * $parent.Form.qty) }}</v-flex>
							</template>

                            <div class="pt-2 pb-2 grey-back full-width" v-if="$parent.Form.productData">
							<template v-if="$parent.hasSeries && !$parent.hasOnlySeries && $root.TransactionSettings.enableBatch">
								<v-radio-group class="pt-3 pl-3 pr-3 pb-1" white-background hide-details v-model="$parent.Form.selectedBatchType" row @change="fn_changeBatchType($event, $parent.Form.productData)">
									<v-radio label="Batch" :value="1"></v-radio>
									<v-radio label="Series" :value="2"></v-radio>
								</v-radio-group>
								<v-divider></v-divider>
							</template>

							<v-subheader class="white-background" v-if="$root.TransactionSettings.enableBatch || ($parent.Form.productData.batches && $parent.Form.productData.batches.length)">
								<!-- {{ seriesFields }} -->
								<template v-if="$parent.Form.selectedBatchType == 2"><span v-for="(field, index) in $parent.seriesFields" :key="field.title">{{ field.title }}<span v-if="$parent.seriesFields.length - 1 != index">/</span></span></template>
								<template v-else>Batches</template>
									<v-spacer></v-spacer> 
								<!-- <v-btn color="primary" capitalize class="mr-0" @click="fn_openDialogSelectBatch">Select/Add</v-btn>  -->
								
								<template v-if="$root.TransactionSettings.enableBatch">
									<!-- <v-btn v-if="product.baseTransactionListId == 10003 && $parent.settings.transactionTypeId == 10004" small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="$parent.fn_openDialogReturnForm('ref_dialogReturnForm')">
										<v-icon class="mr-1" font16 color="primary">edit</v-icon> Change Batch Quantity
									</v-btn> -->

									<v-btn small text outlined capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="$parent.fn_openDialogSelectBatch">
										<v-icon class="mr-1" font16 color="primary">add</v-icon> Add / Select
									</v-btn>
								</template>
								<!-- <v-btn color="primary"  capitalize flat class="mr-0" @click="fn_newBatch">New Batch <v-icon color="primary" class="ml-1">add</v-icon></v-btn> -->
							</v-subheader>
							<template v-if="$parent.Form.productData">
                                <template v-for="(batch, batchIndex) in $parent.Form.productData.batches">
                                    <v-card flat :key="batchIndex" v-if="$parent.fn_showHideBatches(batch)">
                                        <v-divider :key="'divider'+batchIndex" ></v-divider>
                                        <v-card-text class="pb-2">
                                            <div style="float: left;margin-right: 12px;">
                                                <v-btn small nomargin icon @click="$parent.fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
                                            </div>
                                            <v-layout class="batch_layout" row wrap>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
                                                    <div light-opacity-color>Batch No.</div>
                                                    <div>{{ batch.batchNumber }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
                                                    <div light-opacity-color>Size</div>
                                                    <div>{{ batch.batchSize }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
                                                    <div light-opacity-color>MRP</div>
                                                    <div>{{ batch.batchMRP }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
                                                    <div light-opacity-color>Mfg. Date</div>
                                                    <div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
                                                    <div light-opacity-color>Exp. Date</div>
                                                    <div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
                                                    <div light-opacity-color>Purchase Rate</div>
                                                    <div>{{ batch.purchaseRate }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
                                                    <div light-opacity-color>Serial Number</div>
                                                    <div>{{ batch.field1 }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
                                                    <div light-opacity-color>IMEI Number</div>
                                                    <div>{{ batch.field2 }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
                                                    <div light-opacity-color>Part Number</div>
                                                    <div>{{ batch.field3 }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
                                                    <div light-opacity-color>Model Number</div>
                                                    <div>{{ batch.field4 }}</div>
                                                </v-flex>
                                                <v-flex xs4 sm4 md4 mb-2 v-if="$parent.Form.selectedBatchType == 1 && ($parent.Form.productData.batches.length > 1 || ($parent.Form.productData.batches.length == 1 && batch.productQty != $parent.Form.productData.productVariants[0].qty))">
                                                    <div light-opacity-color>Quantity</div>
                                                    <div>{{ batch.productQty }}</div>
                                                </v-flex>
                                            </v-layout>

                                        </v-card-text>
                                    </v-card>
                                </template>
								
							</template>

						</div>

                        </v-layout>				

                        
                      </v-form>

                    </ValidationObserver>
                      
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                     <v-btn color="primary" text @click="fn_checkValidations">Done</v-btn>
                  </v-card-actions>

            </v-card>	
          </v-dialog>
    </div>
</template>	 	

<script>
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'

extend('decimal2', value => {

  let decimalCount = 0;
  if(Math.floor(value) != value){
     decimalCount = value.toString().split(".")[1].length || 0;
  }

  if(decimalCount <= 2){
    return true;
  }

  return 'This field must be numeric and may contain 2 decimal points.';

});

extend('decimal3', value => {

  let decimalCount = 0;
  if(Math.floor(value) != value){
     decimalCount = value.toString().split(".")[1].length || 0;
  }

  if(decimalCount <= 3){
    return true;
  }

  return 'This field must be numeric and may contain 3 decimal points.';

});

export default{
    data(){	
        return{
            dialog_add_product: false,		
        }
    },
    components:{
        ValidationProvider,
        ValidationObserver
    },
    methods:{
        openDialogWeb: function () {	
            this.dialog_add_product = true;
        },
        closeDialogWeb: function () {
            this.dialog_add_product = false;
        },
        fn_checkValidations: function(){
            this.$refs.observer.validate().then((result) => {
                if(result) {    
                  if(!this.$parent.Form.selectedProduct || (this.$parent.Form.selectedProduct && !this.$parent.Form.selectedProduct.itemId) || !this.$parent.Form.qty){
                        this.$eventHub.$emit('snackbarAlert', {msg:'Enter item details'});
                        return;
                    }
                    
                    let obj = {};
                    obj.productId = this.$parent.Form.selectedProduct.itemId;
                    obj.productName = this.$parent.Form.selectedProduct.itemName;
                    obj.qty = this.$parent.Form.qty;
                    // obj.currentStock = this.$parent.Form.qty;
                    obj.unitId = this.$parent.Form.productData.productVariants[0].unitId;
                    obj.unitName = this.$parent.Form.productData.productVariants[0].unitName;
                    obj.productVariantId = this.$parent.Form.productData.productVariants[0].productVariantId;
                    obj.primaryUnitId = this.$parent.Form.productData.productVariants[0].primaryUnitId;
                    obj.secondaryUnitId = this.$parent.Form.productData.productVariants[0].secondaryUnitId;
                    obj.packQuantity = this.$parent.Form.productData.productVariants[0].packQuantity;
                    obj.secondaryUnitPackQuantity = this.$parent.Form.productData.productVariants[0].secondaryUnitPackQuantity;
                    obj.averageRate = this.$parent.Form.averageRate;
                    
                    obj.selectedBatchType = this.$parent.Form.selectedBatchType;

					obj.batches = this.$parent.Form.productData.batches && this.$parent.Form.productData.batches.length ? this.$parent.Form.productData.batches : null;

					// filtering batches as per selected batch type (batch/series)
					if(obj.batches && obj.batches.length){
						obj.batches = obj.batches.filter(batch=>{
							if(obj.selectedBatchType == 1){
								return batch.batchNumber || batch.batchMRP || batch.purchaseRate || batch.batchSize || batch.mfgDate || batch.expDate || batch.opening || batch.field4
							}
							else{
								return  batch.field1 || batch.field2 || batch.field3
							}
						});
					}

                    // let itemIndex = this.$parent.Form.transactionProducts.findIndex(item=>{return item.productId == this.$parent.Form.selectedProduct.itemId});
                    // if(itemIndex == -1){
                    //     this.$parent.Form.transactionProducts.push(obj);
                    // }
                    // else{
                    //    this.$set(this.$parent.Form.transactionProducts, itemIndex,  JSON.parse(JSON.stringify(obj)));
                    // }

                    if(this.$parent.Form.selectedItemIndex != null){
                        this.$set(this.$parent.Form.transactionProducts, this.$parent.Form.selectedItemIndex,  JSON.parse(JSON.stringify(obj)));
					}
					else{
						this.$parent.Form.transactionProducts.push(obj);
					}
                       
                    this.closeDialogWeb();
                }
            })
        },
    }
}
</script>